module.exports = __webpack_public_path__ + "static/img/15.5f14364e.png";